require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./es-mx-campaign-derechos-del-nino.json") })
        }
      }, "path---es-mx-campaign-derechos-del-nino");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---es-mx-campaign-derechos-del-nino!./.cache/json/es-mx-campaign-derechos-del-nino.json
// module id = 883
// module chunks = 231608221292675